var agp = agp || {};

agp.knockout = (function() {
    function init() {
        "use strict";

        ko.numericObservable = function(initialValue) {
            var _actual = ko.observable(initialValue);

            var result = ko.computed({
                read: function() {
                    return _actual();
                },
                write: function(newValue) {
                    var parsedValue = parseFloat(newValue);
                    _actual(isNaN(parsedValue) ? newValue : parsedValue);
                }
            });

            return result;
        }

        ko.oneTimeDirtyFlag = function(root) {
            var _initialized;

            //one-time dirty flag that gives up its dependencies on first change
            var result = ko.computed(function() {
                if (!_initialized) {
                    //just for subscriptions
                    ko.toJS(root);

                    //next time return true and avoid ko.toJS
                    _initialized = true;

                    //on initialization this flag is not dirty
                    return false;
                }

                //on subsequent changes, flag is now dirty
                return true;
            });

            return result;
        };

        ko.dirtyFlag = function(root, isInitiallyDirty) {
            var result = function() {},
                _initialState = ko.observable(ko.toJSON(root)),
                _isInitiallyDirty = ko.observable(isInitiallyDirty);

            result.isDirty = ko.computed(function() {
                return _isInitiallyDirty() || _initialState() !== ko.toJSON(root);
            });

            result.reset = function() {
                _initialState(ko.toJSON(root));
                _isInitiallyDirty(false);
            };

            return result;
        };

        ko.bindingHandlers.openParent = {
            init: function(element) {
                $(element).attrchange({
                    trackValues: true,
                    callback: function(event) {
                        if (event.attributeName == "class") {
                            var $this = $(this);
                            if (event.newValue == "open") {
                                $this.parent().css('display', 'block');
                            } else {
                                $this.parent().css('display', 'none');
                            }
                        }
                    }
                });
            },
        };

        ko.bindingHandlers.datepicker = {
            init: function (element, valueAccessor, allBindingsAccessor) {
                var value = valueAccessor();
                var startDate = ko.utils.unwrapObservable(value);
                var allBindings = allBindingsAccessor();
                var disabledDatesFunction = allBindings.dateDisabledDatesFunction || function () { return []; };
                $(element).val(startDate);
                $(element).Zebra_DatePicker({
                    view: allBindings.dateView || "months",
                    inside: false,
                    show_icon: false,
                    default_position: 'below',
                    days: ["Søndag", "Mandag", "Tirsdag", "Onsdag", "Torsdag", "Fredag", "Lørdag"],
                    direction: allBindings.dateDirection !== null ? allBindings.dateDirection : 0,
                    months: ["Januar", "Februar", "Marts", "April", "Maj", "Juni", "Juli", "August", "September", "Oktober", "November", "December"],
                    show_select_today: "I dag",
                    format: allBindings.dateFormat || "m Y",
                    lang_clear_date: "Ryd dato",
                    pair: allBindings.datePaired ? $(allBindings.datePaired) : null,
                    header_navigation: ['<span class="icon-arrow-left"></span>', '<span class="icon-arrow-right"></span>'],
                    enabled_dates: allBindings.dateEnabledDates || [],
                    disabled_dates: allBindings.dateDisabledDates || [],
                    start_date: allBindings.dateStartDate || '',
                    onSelect: function (date1) {
                        var observable = valueAccessor();
                        observable(date1);
                    },
                    onChange: function (view, elements) {
                        var disabledDates = disabledDatesFunction(); //$(element).data('disabled-dates').split(',') || [];
                        elements.each(function() {
                            var minDate = moment().subtract(5, 'years').startOf('month');
                            //var maxDate = moment().subtract(1, 'months').endOf('month');
                            var maxDate = moment().endOf('month');

                            if (view === 'months') {
                                var currentDate = moment($(this).data('date'), 'YYYY-MM');
                                var dateExists = ko.utils.arrayFirst(disabledDates, function (item) {
                                    return item.isSame(currentDate, 'month');
                                });
                                
                                if (currentDate.isBefore(minDate, 'month') || currentDate.isAfter(maxDate, 'month') || dateExists !== null) {
                                    $(this).addClass('dp_disabled');
                                }
                            }

                            if (view === 'years') {
                                var currentYear = $(this).data('date');
                                if (currentYear < minDate.year() || currentYear > maxDate.year()) {
                                    $(this).addClass('dp_disabled');
                                }
                            }
                        });
                    },
                    onClear: function() {
                        var observable = valueAccessor();
                        observable(null);
                    }
                });
            }
        };

        // Apply chosen-select css
        ko.bindingHandlers.chosen = {
            init: function(element) {
                $(element).addClass('chosen-select');
                $(element).chosen({
                    disable_search_threshold: 1000
                });
            }
        };

        ko.bindingHandlers.visibleFade = {
            init: function(element, valueAccessor) {
                var value = valueAccessor();
                $(element).toggle(value());
            },
            update: function(element, valueAccessor) {
                var value = valueAccessor();
                if (value()) {
                    setTimeout(function() {
                        $(element).fadeOut();
                        value(false);
                    }, 10000);
                }
            }
        }

        var formatNumber = function (element, valueAccessor, allBindingsAccessor, format) {
            // Provide a custom text value
            var value = valueAccessor(), allBindings = allBindingsAccessor();
            var numeralFormat = allBindings.numeralFormat || format;
            var strNumber = ko.utils.unwrapObservable(value);
            return numeral(strNumber).format(numeralFormat);
        };

        ko.bindingHandlers.numeral = {
            init: function (element, valueAccessor, allBindingsAccessor) {
                var value = valueAccessor();
                var interceptor = ko.computed({
                    read: function () {
                        return formatNumber(element, valueAccessor, allBindingsAccessor, "0,0.00");
                    },
                    write: function (newValue) {
                        value(numeral().unformat(newValue));
                        value.valueHasMutated();
                    }
                }).extend({ notify: 'always' });
                if (element.tagName.toLowerCase() == 'input')
                    ko.applyBindingsToNode(element, {
                        value: interceptor,
                        validationTooltip: valueAccessor()
                    });
                else
                    ko.applyBindingsToNode(element, {
                        text: interceptor
                    });
            }
        }

        var formatCpr = function (value) {
            var cpr = ko.utils.unwrapObservable(value);
            if (cpr === undefined || cpr === null || cpr === '' || cpr.length < 9 || cpr.indexOf('-') > 0)
                return cpr;

            var firstIndex = 6;
            if (cpr.length === 9)
                firstIndex = 5;

            var first = cpr.substr(0, firstIndex);
            var second = cpr.substr(firstIndex);
            return first + "-" + second;
        }

        ko.bindingHandlers.cpr = {
            init: function (element, valueAccessor) {
                var value = valueAccessor();
                var interceptor = ko.computed({
                    read: function () {
                        return formatCpr(value);
                    },
                    write: function (newValue) {
                        value(formatCpr(newValue));
                        value.valueHasMutated();
                    }
                }).extend({ notify: 'always' });
                if (element.tagName.toLowerCase() == 'input')
                    ko.applyBindingsToNode(element, {
                        value: interceptor,
                        validationTooltip: valueAccessor()
                    });
                else
                    ko.applyBindingsToNode(element, {
                        text: interceptor
                    });
            }
        };
    }

    return {
        init: init
    };

}());